import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_ARc9841kP',
      userPoolClientId: '26ihrtqvavkchu0bapp9bbr5ne',
      loginWith: {
        oauth: {
          domain: 'logintest.tailor.wf',
          scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: ['http://localhost:3000/'],
          redirectSignOut: ['http://localhost:3000/'],
          responseType: 'code',
        },
      },
    },
  },
};
export default amplifyConfig;
